export default {
  app: {
    title: 'Overpass Planner',
    labs: 'LABS',
  },
  toolbar: {
    layers: 'Couches',
    filters: 'Filtres',
    monitoredAreas: 'Zones surveillées',
    settings: 'Paramètres',
  },
  layers: {
    baseMaps: 'Fonds de carte',
    cloudLayers: 'Couches nuageuses',
    eumetsatTrueRgb: 'EUMETSAT True RGB',
    eumetsatIr: 'EUMETSAT IR 10.8',
    opacity: 'Opacité',
    overlays: 'Superpositions',
    satelliteOverpasses: 'Survols satellites',
    aoiCoverage: 'Couverture ZI',
    hexGrid: 'Grille hexagonale (Prochain survol)',
  },
  filters: {
    title: 'Filtres',
    savePreset: 'Enregistrer le préréglage',
    deletePreset: 'Supprimer le préréglage',
    info: 'Info',
    preset: 'Préréglage',
    cloudCoverForecast: 'Prévision de couverture nuageuse',
    cloudCoverDescription: 'Masquer les survols dont la prévision de couverture nuageuse dépasse ce seuil.',
    satellites: 'Satellites',
    satellitesFilter: 'Filtrer par satellite',
    satellitesDescription: 'Satellites groupés par type de capteur.',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    ororaTechSafire: 'OroraTech SAFIRE',
    showGrouped: 'Afficher groupé',
    showIndividual: 'Afficher individuellement',
    predicted: 'Trajectoire orbitale',
    scheduled: 'Planifié',
    scheduledOnlyNote: 'Les acquisitions programmées sont des fenêtres de tâches confirmées, disponibles uniquement pour les 48 prochaines heures. La trajectoire orbitale est prédite et couvre toute la plage.',
    retired: 'retiré',
    backup: 'secours',
    allSatellites: 'Tous les satellites',
    customPreset: 'Préréglage personnalisé',
    manual: 'Manuel',
    selectedOfTotal: '{selected} sur {total} sélectionnés',
  },
  monitor: {
    title: 'Surveillance',
    addArea: 'Ajouter une zone',
    dropzoneTitle: 'Glissez-déposez des fichiers GeoJSON ici',
    dropzoneSubtitle: 'ou cliquez pour parcourir',
    dropzoneHint: '.geojson ou .json — max 5 Mo par fichier',
    dropFiles: 'Déposer pour importer',
    noAreasYet: 'Aucune zone surveillée pour le moment',
    noAreasDescription: 'Sélectionnez une ZI dans le menu déroulant et cliquez sur {action} pour calculer la couverture.',
    compute: 'Calculer',
    name: 'Nom',
    overpasses: 'Survols',
    calculated: 'Calculé',
    computing: 'Calcul en cours...',
    area: 'Surface',
    export: 'Exporter',
    delete: 'Supprimer',
    clickToPan: 'Cliquer pour centrer, double-cliquer pour renommer',
    selected: '{count} sélectionné(s)',
  },
  list: {
    title: 'Survols',
    satellite: 'Satellite',
    direction: 'Direction',
    start: 'Début',
    end: 'Fin',
    sensor: 'Capteur',
    resolution: 'Résolution',
    light: 'Lumière',
    cloud: 'Nuages',
    latency: 'Latence',
    delivery: 'Livraison',
    loading: 'Chargement des données satellites...',
    zoomIn: 'Zoomez pour voir les survols individuels.',
    noOverpasses: 'Aucun survol visible avec les filtres actuels.',
    uploadAoiToView: 'Téléchargez une zone d\'intérêt pour voir les données de survol.',
    selectGridCell: 'Sélectionnez une cellule de la grille pour voir les données de survol.',
    day: 'jour',
    night: 'nuit',
    close: 'Fermer',
    maxCloudCover: 'Couverture nuageuse max : {value}%',
  },
  popup: {
    start: 'Début',
    end: 'Fin',
    direction: 'Direction',
    ascending: 'Ascendante',
    descending: 'Descendante',
    sensor: 'Capteur',
    resolution: 'Résolution',
    constellation: 'Constellation',
    daylight: 'Lumière du jour',
    day: 'Jour',
    night: 'Nuit',
    dayEmoji: '☀ Jour',
    nightEmoji: '🌙 Nuit',
    cloudCoverForecast: 'Prévision de couverture nuageuse',
    cloudCoverObserved: 'Couverture nuageuse (observée)',
    notCalculated: 'Non calculée',
    expectedLatency: 'Latence attendue',
    expectedDelivery: 'Livraison attendue',
    from: 'De',
    to: 'À',
    coverage: '{pct}% Couverture',
    areaCovered: 'Zone couverte',
  },
  timeline: {
    title: 'Graphique chronologique',
    coveragePct: 'Couverture %',
    allSatellites: 'Tous les satellites',
    bySatellite: 'Par satellite',
    bySensor: 'Par capteur',
    restore: 'Restaurer',
    maximize: 'Agrandir',
    close: 'Fermer',
    uploadAoiTimeline: 'Téléchargez une zone d\'intérêt pour voir la chronologie.',
    selectGridTimeline: 'Sélectionnez une cellule de la grille pour voir la chronologie.',
  },
  hexLegend: {
    title: 'Temps avant le prochain survol',
    expandLegend: 'Développer la légende',
    collapseLegend: 'Réduire la légende',
    noOverpasses: 'Aucun survol dans les {hours} prochaines heures',
    notComputed: "Non calculé pour cette période",
    coveragePast: "La grille est précalculée à partir de la dernière génération : les passages passés ne sont pas disponibles ici. Utilisez la vue fauchées ou ZI pour les dates passées.",
    coverageOtOnly: "Au-delà du {date}, la grille ne couvre que la constellation OroraTech.",
    coverageBeyondAll: "La grille s'arrête au {date}. Rien n'est précalculé au-delà.",
    cellsSelected: '{count} cellule(s) sélectionnée(s)',
    clear: 'Effacer',
  },
  hexTooltip: {
    nextOverpass: 'Prochain survol',
    satellite: 'Satellite',
    acquisition: "Heure d'acquisition",
    cloudForecast: 'Prévision nuageuse',
    status: 'Statut',
    noOverpass: 'Aucun survol dans la fenêtre sélectionnée',
    timeIn: 'Dans',
    totalPasses: 'Total des passages',
  },
  settings: {
    language: 'Langue',
    theme: 'Thème',
    light: 'Clair',
    dark: 'Sombre',
    timezone: 'Fuseau horaire',
    local: 'Local',
    colorblindFriendly: 'Couleurs adaptées au daltonisme',
  },
  timeControls: {
    start: 'Début',
    end: 'Fin',
    now: 'Maintenant',
    showGraph: 'Afficher le graphique',
    hideGraph: 'Masquer le graphique',
    showPanel: 'Afficher le panneau',
    hidePanel: 'Masquer le panneau',
    setStartToNow: 'Définir le début à maintenant',
    resetTimeRange: 'Réinitialiser la plage horaire',
    gridCoverageHint: "Précalculé : tous les satellites jusqu'au {allSatellitesEnd}, OroraTech seul jusqu'au {end}. Pas de dates passées.",
  },
  viewToggle: {
    aoi: 'ZI',
    grid: 'Grille',
    swaths: 'Fauchées',
    aoiTitle: 'Vue ZI — Afficher uniquement la couverture ZI',
    gridTitle: 'Vue grille — Temps avant le prochain survol',
    swathTitle: 'Vue fauchées',
  },
  geocoder: {
    searchPlaceholder: 'Rechercher un lieu…',
    coordinates: 'Coordonnées',
    noResults: 'Aucun résultat pour',
    clearSearch: 'Effacer la recherche',
    trackGeolocation: 'Suivre la géolocalisation',
    toggleGeolocation: 'Activer/désactiver la géolocalisation',
  },
  aoi: {
    selectOrUpload: 'Sélectionner ou télécharger une ZI…',
    compute: 'Calculer',
    computing: 'Calcul en cours…',
    uploadGeoJson: 'Télécharger un GeoJSON ZI',
    aoiLabel: 'ZI',
    clearAoi: 'Effacer la ZI',
    uploadNew: 'Télécharger un nouveau GeoJSON…',
    computeCoverage: 'Calculer la couverture',
  },
  startup: {
    title: 'Commencez avec une zone d\'intérêt',
    body: 'Téléchargez une ZI pour lancer les calculs de couverture, ou continuez avec une vue globale.',
    dropzoneTitle: 'Glissez-déposez des fichiers GeoJSON ici',
    dropzoneSubtitle: 'ou cliquez pour parcourir',
    dropzoneHint: '.geojson ou .json — max 5 Mo par fichier',
    or: 'ou',
    uploadAoi: 'Télécharger une ZI',
    continueGlobal: 'Continuer en vue globale',
  },
  common: {
    zoomInHint: 'Zoomez pour voir les informations de survol satellite',
    openOverpassList: 'Ouvrir la liste des survols',
    cloudCoverForecast: 'Prévision de couverture nuageuse',
    groupedConstellation: 'Constellation groupée',
    individualSatellites: 'Satellites individuels',
  },
};
